import { render, staticRenderFns } from "./NextPhar.vue?vue&type=template&id=534b2f01&scoped=true"
import script from "./NextPhar.vue?vue&type=script&lang=js"
export * from "./NextPhar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534b2f01",
  null
  
)

export default component.exports